import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoldReportViewerComponent } from './reportviewer.component';
export class BoldReportViewerModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule
    ],
    declarations: [
        BoldReportViewerComponent
    ],
    exports: [
        BoldReportViewerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoldReportViewerModule_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportViewerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoldReportViewerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
